import { useReports, useUpdateShare } from '../hooks/useReports';
import Badge from '../components/ui/Badge';
import ScorePill from '../components/ui/ScorePill';
import { useState } from 'react';

export default function ShareLinks() {
  const { data } = useReports();
  const updateShare = useUpdateShare();
  const reports = data?.data || [];
  const sharedReports = reports.filter(r => r.is_shared);
  const [copied, setCopied] = useState(null);

  const copyLink = (token) => {
    navigator.clipboard.writeText(`https://plattform.konversion.digital/share/${token}`);
    setCopied(token);
    setTimeout(() => setCopied(null), 2000);
  };

  const toggleShare = (report) => {
    updateShare.mutate({ id: report.id, is_shared: !report.is_shared });
  };

  return (
    <div>
      <div className="mb-5">
        <h1 className="text-[23px] font-bold mb-0.5">Share-Links</h1>
        <p className="text-gray-500 text-[13.5px]">Öffentlich geteilte CRO-Berichte verwalten</p>
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-black/[.07]">
        <table className="w-full">
          <thead>
            <tr className="border-b border-gray-200 text-left">
              <th className="px-5 py-3.5 text-[12px] text-gray-500 font-medium">Bericht</th>
              <th className="px-5 py-3.5 text-[12px] text-gray-500 font-medium">Score</th>
              <th className="px-5 py-3.5 text-[12px] text-gray-500 font-medium">Status</th>
              <th className="px-5 py-3.5 text-[12px] text-gray-500 font-medium">Aufrufe</th>
              <th className="px-5 py-3.5 text-[12px] text-gray-500 font-medium">Passwort</th>
              <th className="px-5 py-3.5 text-[12px] text-gray-500 font-medium text-right">Aktionen</th>
            </tr>
          </thead>
          <tbody>
            {sharedReports.map((r) => (
              <tr key={r.id} className="border-b border-gray-100 last:border-0 hover:bg-gray-50/50">
                <td className="px-5 py-3.5">
                  <div className="text-[13px] font-medium truncate max-w-[260px]">{r.url || r.client_name || `Report #${r.id}`}</div>
                  <div className="text-[11px] text-gray-500">{new Date(r.created_at).toLocaleDateString('de')}</div>
                </td>
                <td className="px-5 py-3.5"><ScorePill score={r.score || 0} /></td>
                <td className="px-5 py-3.5">
                  <Badge bg="#D1FAE5" color="#10B981">Aktiv</Badge>
                </td>
                <td className="px-5 py-3.5 text-[12.5px] font-medium">{r.view_count || 0}</td>
                <td className="px-5 py-3.5">
                  {r.share_password ? (
                    <Badge bg="#DBEAFE" color="#3B82F6">Geschützt</Badge>
                  ) : (
                    <Badge bg="#F3F4F6" color="#6B7280">Offen</Badge>
                  )}
                </td>
                <td className="px-5 py-3.5 text-right">
                  <div className="flex gap-2 justify-end">
                    <button
                      onClick={() => copyLink(r.share_token)}
                      className="border border-gray-200 rounded-lg px-3 py-1.5 text-[12px] hover:bg-gray-50"
                    >
                      {copied === r.share_token ? 'Kopiert!' : 'Link kopieren'}
                    </button>
                    <button
                      onClick={() => toggleShare(r)}
                      className="border border-red-light text-red rounded-lg px-3 py-1.5 text-[12px] hover:bg-red-light"
                    >
                      Deaktivieren
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {sharedReports.length === 0 && (
          <div className="py-12 text-center text-gray-400 text-sm">
            Keine aktiven Share-Links. Teile einen Bericht über die Reports-Seite.
          </div>
        )}
      </div>
    </div>
  );
}
